"use client";

import { c as _c } from "react/compiler-runtime";
import { addConnectedProfile, isProfileConnected } from "@/lib/utils/connected-profiles-storage";
import CheckIcon from "@mui/icons-material/Check";
import TodayRoundedIcon from "@mui/icons-material/TodayRounded";
import { Box, Button, Fade } from "@mui/material";
import { useEffect, useState } from "react";
import { pushGtmEvent } from "../../../../../lib/utils/gtmEventHandler";
import { useDpStore } from "../../../../../store/dpStore";
import EnquiryModal from "./EnquiryFlowNew/EnquiryModal";
import LocationModal from "./EnquiryFlowNew/LocationModal";
import MapModal from "./EnquiryFlowNew/MapModal";
import SuccessModal from "./SuccessModal";
import EventRepeatRoundedIcon from '@mui/icons-material/EventRepeatRounded';
import { useEnquiryFlowStore } from "@/store/enquiryFlowStore";
import { getLastEnquiry } from "@/lib/utils/last-enquiry-storage";
import { getSurveyAnswers, isSurveyCompleted } from "@/lib/utils/survey-storage";
import { useSurveySheetStore } from "@/store/surveySheetStore";
import { validateWhatsAppNumber } from "@/lib/utils/connect-form-validation";
import { inhomzEvents } from "@/app/(fevicol-inhomz)/_lib/events";
import { profileEventProps } from "@/app/(fevicol-inhomz)/_lib/profileEventProps";
import { useInhomzTrack } from "@/app/(fevicol-inhomz)/_hooks/useInhomzTrack";

// `placement` says which get-in-touch button this is (bottom_bar | sidebar | photo_overlay).
const ConnectButton = t0 => {
  const $ = _c(67);
  const {
    digitalProfile,
    gtmEventData,
    onClose,
    placement
  } = t0;
  const track = useInhomzTrack();
  const openMandatory = useEnquiryFlowStore(_temp);
  const openReview = useEnquiryFlowStore(_temp2);
  const resumeAtSurvey = useEnquiryFlowStore(_temp3);
  const goToReview = useEnquiryFlowStore(_temp4);
  const backToMandatory = useEnquiryFlowStore(_temp5);
  const openSurvey = useSurveySheetStore(_temp6);
  const enquiryFlowActiveStep = useEnquiryFlowStore(_temp7);
  const {
    enquiryFormData,
    setEnquiryFormData,
    showTempButton,
    setShowTempButton,
    successModalOpen,
    setSuccessModalOpen
  } = useDpStore();
  const [isEnquiryAlreadySent, setIsEnquiryAlreadySent] = useState(false);
  let t1;
  if ($[0] !== backToMandatory || $[1] !== digitalProfile || $[2] !== enquiryFormData || $[3] !== goToReview || $[4] !== gtmEventData || $[5] !== isEnquiryAlreadySent || $[6] !== onClose || $[7] !== openMandatory || $[8] !== openReview || $[9] !== openSurvey || $[10] !== placement || $[11] !== resumeAtSurvey || $[12] !== setEnquiryFormData || $[13] !== track) {
    t1 = () => {
      track(inhomzEvents.contractorProfile.GET_IN_TOUCH_CLICKED, {
        ...profileEventProps(digitalProfile),
        placement,
        event_value: isEnquiryAlreadySent ? "get_in_touch_again" : "get_in_touch"
      });
      onClose?.();
      const last = getLastEnquiry();
      const surveyAnswers = getSurveyAnswers();
      const hasSavedDetails = last?.workTypes?.length > 0 && last.fullName?.trim() && validateWhatsAppNumber(last.contactNumber) && last.siteLocation?.trim();
      if (!hasSavedDetails) {
        openMandatory(digitalProfile);
      } else {
        setEnquiryFormData({
          ...enquiryFormData,
          siteLocation: last.siteLocation,
          siteLocationDetails: last.siteLocationDetails || null
        });
        if (isSurveyCompleted(surveyAnswers)) {
          openReview({
            digitalProfile,
            mandatoryData: last,
            surveyAnswers
          });
        } else {
          resumeAtSurvey({
            digitalProfile,
            mandatoryData: last,
            surveyAnswers
          });
          openSurvey({
            initialAnswers: Object.keys(surveyAnswers).length ? surveyAnswers : undefined,
            onComplete: answers => goToReview({
              surveyAnswers: answers
            }),
            onSkip: answers_0 => goToReview({
              surveyAnswers: answers_0
            }),
            onBack: () => backToMandatory(last),
            context: "enquiryFlow"
          });
        }
      }
      if (isEnquiryAlreadySent) {
        pushGtmEvent({
          event_name: "enquire_again_clicked",
          ...gtmEventData
        });
      } else {
        pushGtmEvent({
          event_name: "contractor_profile_page_action_taken",
          event_action: "enquire_now_clicked",
          ...gtmEventData
        });
      }
    };
    $[0] = backToMandatory;
    $[1] = digitalProfile;
    $[2] = enquiryFormData;
    $[3] = goToReview;
    $[4] = gtmEventData;
    $[5] = isEnquiryAlreadySent;
    $[6] = onClose;
    $[7] = openMandatory;
    $[8] = openReview;
    $[9] = openSurvey;
    $[10] = placement;
    $[11] = resumeAtSurvey;
    $[12] = setEnquiryFormData;
    $[13] = track;
    $[14] = t1;
  } else {
    t1 = $[14];
  }
  const handleEnquiryClick = t1;
  let t2;
  if ($[15] !== setSuccessModalOpen) {
    t2 = () => {
      setSuccessModalOpen(false);
    };
    $[15] = setSuccessModalOpen;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  const handleSuccessModalClose = t2;
  let t3;
  if ($[17] !== digitalProfile?.contractorId || $[18] !== digitalProfile?.profileName || $[19] !== handleSuccessModalClose) {
    t3 = function handleSuccessModalOkay() {
      if (digitalProfile?.contractorId && digitalProfile?.profileName) {
        addConnectedProfile(digitalProfile?.contractorId, digitalProfile?.profileName);
      }
      handleSuccessModalClose();
    };
    $[17] = digitalProfile?.contractorId;
    $[18] = digitalProfile?.profileName;
    $[19] = handleSuccessModalClose;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  const handleSuccessModalOkay = t3;
  let t4;
  let t5;
  if ($[21] !== setShowTempButton || $[22] !== showTempButton) {
    t4 = () => {
      if (showTempButton === true) {
        const timer = setTimeout(() => {
          setShowTempButton(false);
        }, 10000);
        return () => {
          clearTimeout(timer);
          setShowTempButton(false);
        };
      }
    };
    t5 = [showTempButton, setShowTempButton];
    $[21] = setShowTempButton;
    $[22] = showTempButton;
    $[23] = t4;
    $[24] = t5;
  } else {
    t4 = $[23];
    t5 = $[24];
  }
  useEffect(t4, t5);
  let t6;
  if ($[25] !== digitalProfile?.contractorId) {
    t6 = () => {
      setIsEnquiryAlreadySent(isProfileConnected(digitalProfile?.contractorId));
    };
    $[25] = digitalProfile?.contractorId;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  const t7 = digitalProfile?.contractorId;
  let t8;
  if ($[27] !== enquiryFlowActiveStep || $[28] !== successModalOpen || $[29] !== t7) {
    t8 = [t7, successModalOpen, enquiryFlowActiveStep];
    $[27] = enquiryFlowActiveStep;
    $[28] = successModalOpen;
    $[29] = t7;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  useEffect(t6, t8);
  let t9;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      position: "relative",
      width: "100%",
      height: "40px"
    };
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  const t10 = !showTempButton;
  let t11;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      position: "absolute",
      width: "100%",
      top: 0,
      left: 0
    };
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      height: "40px",
      width: "100%",
      borderRadius: "30px",
      backgroundColor: "var(--colorPrimaryPrimary, #004BEE)",
      color: "var(--textPrimaryOnColorPrimary, #F2F1E9)",
      textTransform: "none",
      "&:hover": {
        backgroundColor: "var(--colorPrimaryPrimary, #004BEE)"
      }
    };
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== isEnquiryAlreadySent) {
    t13 = isEnquiryAlreadySent ? <EventRepeatRoundedIcon /> : <TodayRoundedIcon />;
    $[34] = isEnquiryAlreadySent;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  const t14 = isEnquiryAlreadySent ? "Get in touch again" : "Get in touch";
  let t15;
  if ($[36] !== handleEnquiryClick || $[37] !== t13 || $[38] !== t14) {
    t15 = <Box sx={t11}><Button onClick={handleEnquiryClick} className="!m3-label-large" sx={t12} startIcon={t13}>{t14}</Button></Box>;
    $[36] = handleEnquiryClick;
    $[37] = t13;
    $[38] = t14;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== t10 || $[41] !== t15) {
    t16 = <Fade in={t10} timeout={1000} unmountOnExit={true}>{t15}</Fade>;
    $[40] = t10;
    $[41] = t15;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      position: "absolute",
      width: "100%",
      top: 0,
      left: 0
    };
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Box sx={t17}><Button className="!m3-label-large" variant="outlined" startIcon={<CheckIcon />} sx={{
        height: "40px",
        width: "100%",
        borderRadius: "30px",
        borderColor: "var(--colorSecondarySecondary, #5A5D72)",
        color: "var(--textSecondarySecondary, #5E5F59)"
      }}>Enquiry Submitted</Button></Box>;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== showTempButton) {
    t19 = <Fade in={showTempButton} timeout={1000} unmountOnExit={true}>{t18}</Fade>;
    $[45] = showTempButton;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== t16 || $[48] !== t19) {
    t20 = <Box sx={t9}>{t16}{t19}</Box>;
    $[47] = t16;
    $[48] = t19;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] !== digitalProfile || $[51] !== setSuccessModalOpen) {
    t21 = <EnquiryModal digitalProfile={digitalProfile} setSuccessModalOpen={setSuccessModalOpen} />;
    $[50] = digitalProfile;
    $[51] = setSuccessModalOpen;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  let t22;
  let t23;
  if ($[53] !== digitalProfile) {
    t22 = <LocationModal digitalProfile={digitalProfile} />;
    t23 = <MapModal digitalProfile={digitalProfile} />;
    $[53] = digitalProfile;
    $[54] = t22;
    $[55] = t23;
  } else {
    t22 = $[54];
    t23 = $[55];
  }
  const t24 = digitalProfile?.profileName;
  let t25;
  if ($[56] !== handleSuccessModalClose || $[57] !== handleSuccessModalOkay || $[58] !== successModalOpen || $[59] !== t24) {
    t25 = <SuccessModal open={successModalOpen} onClose={handleSuccessModalClose} onOkay={handleSuccessModalOkay} contractorName={t24} />;
    $[56] = handleSuccessModalClose;
    $[57] = handleSuccessModalOkay;
    $[58] = successModalOpen;
    $[59] = t24;
    $[60] = t25;
  } else {
    t25 = $[60];
  }
  let t26;
  if ($[61] !== t20 || $[62] !== t21 || $[63] !== t22 || $[64] !== t23 || $[65] !== t25) {
    t26 = <>{t20}{t21}{t22}{t23}{t25}</>;
    $[61] = t20;
    $[62] = t21;
    $[63] = t22;
    $[64] = t23;
    $[65] = t25;
    $[66] = t26;
  } else {
    t26 = $[66];
  }
  return t26;
};
export default ConnectButton;
function _temp(state) {
  return state.openMandatory;
}
function _temp2(state_0) {
  return state_0.openReview;
}
function _temp3(state_1) {
  return state_1.resumeAtSurvey;
}
function _temp4(state_2) {
  return state_2.goToReview;
}
function _temp5(state_3) {
  return state_3.backToMandatory;
}
function _temp6(state_4) {
  return state_4.open;
}
function _temp7(state_5) {
  return state_5.activeStep;
}